export default __webpack_public_path__ + "static/media/Bladefeint Sabatons.81a805ef.jpg";